import {
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILED
} from '../../types';

const initialState = {
  notifications: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchNotificationsReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        isLoading: true,
          notifications: action.payload
      }
      case FETCH_NOTIFICATIONS_SUCCESS:
        return {
          ...state,
          isLoading: false,
            notifications: action.payload
        }
        case FETCH_NOTIFICATIONS_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchNotificationsReducer;
